import { render, staticRenderFns } from "./UpdateLatestPriority.vue?vue&type=template&id=9e11d4f2&"
import script from "./UpdateLatestPriority.vue?vue&type=script&lang=js&"
export * from "./UpdateLatestPriority.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLatestPriority.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports